











































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { UploadData } from '@/interface/components';

@Component
export default class ModalImport extends Vue {
  @PropSync('dialogVisibleImport', { type: Boolean }) syncedDialogVisibleImport!: boolean;
  @Action('getTemplateRequest', { namespace: 'request' }) c_getTemplateRequest!: any;
  @Action('getTemplateInventory', { namespace: 'inventory' }) c_getTemplateInventory!: any;
  @Action('signUrlRequestImport', { namespace: 'request' }) c_signUrlRequestImport!: any;
  @Action('signUrlInventoryImport', { namespace: 'inventory' }) c_signUrlInventoryImport!: any;
  @Action('inventoryUpload', { namespace: 'inventory' }) c_inventoryUpload!: any;
  @Action('requestUpload', { namespace: 'request' }) c_requestUpload!: any;
  @Action('getImport') c_getImport!: any;
  @Action('getInventory', { namespace: 'inventory' }) c_getInventory!: any;
  @Action('getRequests', { namespace: 'request' }) c_getRequests!: any;

  @Action('getMainLocations', { namespace: 'manageGroup' }) c_getMainLocations!: any;
  @Action('getVendors', { namespace: 'manageGroup' }) c_getVendors!: any;
  @Action('getTypes', { namespace: 'manageGroup' }) c_getTypes!: any;
  @Action('getMembers', { namespace: 'manageGroup' }) c_getMembers!: any;
  @Action('getPurchaseOrders', { namespace: 'request' }) c_getPurchaseOrders!: any;
  @Action('getGrants', { namespace: 'manageGroup' }) c_getGrants!: any;

  public currentUploading: number = 0;
  public file: any = null;
  public timeCtrl: any = null;
  public uploadLoading: boolean = false;
  public templateLoading: boolean = false;

  public inventoryAttributes: string =
    'id,name,serialNumber,catalogNumber,unit,unitSize,quantity,price,ownedBy,url,casNumber,lotNumber,expiresOn,technicalDetails,boughtFrom,expirationReminder,customFields,vendorName,isArchived,createdBy,createdAt,updatedBy,updatedAt,lastReceivedAt,fkTypeId,fkVendorId,fkLocationId,fkLocationSubId,notes';
  public inventoryLimit: number = 20;
  public inventoryOffset: number = 0;
  public inventorySort: string = '-updatedAt';
  public inventoryInclude: string = 'fkType,fkVendor,fkLocation,fkLocationSub,fkOwnedBy';
  public inventoryKeyword: string = '';

  public queryAttributes: string =
    'id,catalogNumber,name,url,unitSize,quantity,quantityReceived,price,createdBy,isUrgent,requiredBefore,requisitionNumber,confirmationNumber,trackingNumber,invoiceNumber,statusChangedAt,fkTypeId,notes,createdAt,status,updatedAt,fkVendorId,requestedBy,fkPurchaseOrderId,expectedOn';
  public queryLimit: number = 20;
  public queryOffset: number = 0;
  public querySort: string = '-statusChangedAt';
  public queryInclude: string = 'fkType,fkVendor,fkRequestedBy,fkPurchaseOrder';
  public queryKeyword: string = '';
  public queryHasDropdown: boolean = false;
  public statusList = {
    status: ['PENDING'],
  };

  created() {
    const {
      attributes,
      limit,
      offset,
      sort,
      include,
      query,
      status,
      hasDropdown,
    }: any = this.$route.query;
    if (this.$route.name !== 'ContentView') {
      if (attributes) this.queryAttributes = attributes;
      if (limit) this.queryLimit = limit;
      if (offset) this.queryOffset = offset;
      if (sort) this.querySort = sort;
      if (include) this.queryInclude = include;
      if (query) this.queryKeyword = query;
      if (hasDropdown) this.queryHasDropdown = hasDropdown;
      if (status) {
        if (Array.isArray(status)) {
          this.statusList = {
            status: status,
          };
        } else {
          this.statusList = {
            status: [status],
          };
        }
      }
    } else {
      if (attributes) this.inventoryAttributes = attributes;
      if (limit) this.inventoryLimit = limit;
      if (offset) this.inventoryOffset = offset;
      if (sort) this.inventorySort = sort;
      if (include) this.inventoryInclude = include;
      if (query) this.inventoryKeyword = query;
    }
  }

  async templateDownload() {
    this.templateLoading = true;
    let result: any = null;
    const groupId: string = this.$route.params.groupId;
    let linkEl: any = document.createElement('a');

    try {
      this.$route.name === 'StatusView'
        ? (result = await this.c_getTemplateRequest(groupId))
        : (result = await this.c_getTemplateInventory(groupId));
      this.templateLoading = false;
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
      this.templateLoading = false;
    }

    linkEl.setAttribute('href', result.url);
    (this.$refs.dataList as any).appendChild(linkEl);
    linkEl.click();
    (this.$refs.dataList as any).removeChild(linkEl);
    linkEl = null;
  }

  async initLoad() {
    const groupId: string = this.$route.params.groupId;
    try {
      this.$route.name === 'StatusView'
        ? await this.c_getRequests({
            groupId,
            attributes: this.queryAttributes,
            offset: this.queryOffset,
            limit: this.queryLimit,
            order: this.querySort,
            include: this.queryInclude,
            query: this.queryKeyword,
            status: this.statusList,
            hasDropdown: this.queryHasDropdown,
          })
        : await this.c_getInventory({
            groupId,
            attributes: this.inventoryAttributes,
            offset: this.inventoryOffset,
            limit: this.inventoryLimit,
            order: this.inventorySort,
            include: this.inventoryInclude,
            query: this.inventoryKeyword,
          });
      // 데이터 재로드
      if (groupId && groupId !== 'welcome') {
        this.c_getMainLocations(groupId);
        this.c_getTypes(groupId);
        this.c_getVendors(groupId);
        this.c_getMembers(groupId);
        this.c_getPurchaseOrders({
          groupId,
        });
        this.c_getGrants(groupId);
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async uploadFile(changeEvent: any) {
    this.uploadLoading = true;
    const groupId = this.$route.params.groupId;
    this.file = changeEvent.target.files[0];
    try {
      const uploadPayload = {
        groupId,
        payload: {
          Bucket: 'images.labsby.com',
          Key: `groups/${groupId}/imports/${this.file.name}`,
        },
      };
      let uploadData: UploadData;
      if (this.$route.name === 'StatusView') {
        await this.c_signUrlRequestImport({ groupId, file: this.file });
        uploadData = await this.c_requestUpload(uploadPayload);
      } else {
        await this.c_signUrlInventoryImport({ groupId, file: this.file });
        uploadData = await this.c_inventoryUpload(uploadPayload);
        console.log(uploadData);
      }

      this.timeCtrl = setInterval(async () => {
        const iter: any = await this.c_getImport({ importId: uploadData.id });
        this.currentUploading = iter.progress;
        if (iter.status === 'DONE') {
          await clearInterval(this.timeCtrl);
          setTimeout(this.handleClose, 1000);
          await this.initLoad();
        }
      }, 500);
      // @ts-ignore
      this.$refs.file.value = '';
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
      // @ts-ignore
      this.$refs.file.value = '';
      this.uploadLoading = false;
    }
  }

  uploadHandle() {
    (this.$refs.file as HTMLFormElement).click();
  }

  handleClose() {
    this.syncedDialogVisibleImport = false;
    this.uploadLoading = false;
  }
}
